















































import PageBase, {BreadCrumb} from '@/pages/page-base'
import axios from 'axios'
import {apiV1AdminJobsPath, apiV1AdminTagPath} from '@/rails/routes'
import {DataTableHeader} from 'vuetify'
import {Component} from 'vue-property-decorator'
import Job, {IJob} from '@/models/Job'
import Tag, {ITag} from '@/models/Tag'
import ListCount from '@/components/admin/ListCount.vue'

@Component({
  components: {
    ListCount
  }
})
export default class JobsIndex extends PageBase {
  headers: Array<DataTableHeader> = [
    { text: '会社名', value: 'recruit.title', width: 300 },
    { text: '契約形態', value: 'recruit.planString', width: 300 },
    { text: '職種', value: 'tagCategory.name' , width: 400 },
    { text: '雇用形態', value: 'contract_type', width: 600 },
    { text: '仕事内容', value: 'description', width: 600 },
    { text: '必要なスキル・経験', value: 'qualification', width: 600 },
    { text: '給与', value: 'salary', width: 600 },
    { text: '福利厚生・各種手当・マイカー通勤 他', value: 'welfare', width: 600 },
    { text: '勤務時間', value: 'hours', width: 600 },
    { text: '勤務地', value: 'location', width: 600 },
    { text: '休日・休暇', value: 'vacation', width: 600 },
  ]
  jobs: Array<Job> = []
  tags: Array<Tag> = []
  keyword = ''
  filterMode = 'all'

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '職種別求人情報一覧'
      }
    ]
  }

  get viewPosts(): Array<Job> {
    if (this.filterMode === 'all') {
      return this.filteredRecruits(this.jobs)
    } else {
      return this.filteredRecruits(this.jobs.filter(job => job.tag.parent.slug === this.filterMode))
    }
  }

  filteredRecruits(jobs: Array<Job>): Array<Job> {
    if (this.keyword) {
      const keyword = this.keyword.toLocaleLowerCase()
      return jobs.filter(
        job => job.recruit.title.toLocaleLowerCase().includes(keyword) ||
          job.tagCategory.name.toLocaleLowerCase().includes(keyword) ||
          job.title.toLocaleLowerCase().includes(keyword) ||
          job.contract_type.toLocaleLowerCase().includes(keyword) ||
          job.description.toLocaleLowerCase().includes(keyword) ||
          job.qualification.toLocaleLowerCase().includes(keyword) ||
          job.salary.toLocaleLowerCase().includes(keyword) ||
          job.welfare.toLocaleLowerCase().includes(keyword) ||
          job.hours.toLocaleLowerCase().includes(keyword) ||
          job.location.toLocaleLowerCase().includes(keyword) ||
          job.vacation.toLocaleLowerCase().includes(keyword)
      )
    }
    return jobs
  }

  mounted(): void {
    this.reload()
    super.mounted()
  }

  async reload(): Promise<void> {
    try {
      this.loading = true
      const jobs = await axios.get<Array<IJob>>(apiV1AdminJobsPath())
      this.jobs = jobs.data.map(j => new Job(j))
      const rootTag = await axios.get<ITag>(apiV1AdminTagPath('recruit_cat'))
      this.tags = new Tag(rootTag.data).children
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }
}
